import React, { useEffect } from "react";
// import PlayerInfo from "../components/PlayerInfo";
import Page from "../components/Page";
import UserInfo from "../components/UserInfo";
import MyPredictions from "../components/MyPredictions";
import Head from "../components/Head";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import MyDuel from "../components/MyDuel";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import DoneOutlineIcon from "@mui/icons-material/DoneOutline";
import { getShownRound, isLiveMatches } from "../utils";
import { fetchMatches } from "../actions/matches";
import MatchesAutoFetcher from "../components/MatchesAutoFetcher";

const Home = ({ loaded, me, matches, autoRefreshInterval, gameNumber }) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollToTopDisabled = false;
  }, [me]);

  if (me && me?.Registered === 0) {
    navigate("/registration");
  }

  const hasDuel = me?.duel?.DuelId;
  const isRefreshable = Boolean(autoRefreshInterval) && isLiveMatches(matches);

  return (
    <Page classes="h-[100%]">
      <div
        id="player-panel"
        className="pb-2 fixed w-full top-16 z-[999] bg-primary text-gold max-w-screen-lg border-t-[4px] border-solid [border-image:linear-gradient(45deg,#90fcd5,#0313a6)_1]"
      >
        <UserInfo loaded={loaded} />

        <Head
          hasGradient={false}
          loaded={loaded}
          icon={hasDuel ? null : <HourglassBottomIcon className="!text-2xl" />}
          action={<MyDuel duel={me?.duel} hasDuel={hasDuel} />}
        />

        <Head
          onClick={() => navigate("/roundDuels/" + gameNumber)}
          icon={<DoneOutlineIcon className="!text-2xl" />}
          loaded={loaded}
          text={
            me?.Active ? `Тур ${getShownRound(gameNumber)}` : "Гру завершено"
          }
        />
      </div>
      <MyPredictions hasDuel={hasDuel} loaded={loaded} meActive={me?.Active} />
      {isRefreshable && (
        <MatchesAutoFetcher autoRefreshInterval={autoRefreshInterval} />
      )}
    </Page>
  );
};

const mapStateToProps = (state) => ({
  loaded: state.app.loaded,
  me: state.user.me,
  gameNumber: state.user.gameNumber,
  matches: state.matches,
  autoRefreshInterval: state?.user?.autoRefreshInterval,
});

const mapDispatchToProps = (dispatch) => ({
  fetchMatches: () => dispatch(fetchMatches()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Home);
